import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@gl/api-client';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});

/**
 * Query keys de la fase A. Los módulos de la fase B definen las suyas en su carpeta,
 * colgando de `queryKeys.local(localId)` para que se invaliden al cambiar de local:
 *   ['locals', localId, 'catalog'], ['locals', localId, 'sales', ...], etc.
 */
export const queryKeys = {
  me: ['me'] as const,
  locals: ['locals'] as const,
  local: (localId: string) => ['locals', localId] as const,
  members: (localId: string) => ['locals', localId, 'members'] as const,
  checkSlug: (slug: string) => ['check-slug', slug] as const,
};
